import { createStyles, makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    primaryColor: {
      color: `${MaterialPalette.primary.main}`,
    },
    card: {
      padding: 16,
    },
    cursor: {
      cursor: 'pointer',
      '& .dateGrid': {
        marginRight: 50,
        fontSize: 20,
        color: 'rgba(255,255,255,0.87)',
        fontWeight: 300,
        verticalAlign: 'center',
      },
    },
    grid: {
      fontSize: 24,
      color: 'rgba(255,255,255,0.87)',
      fontWeight: 300,
      verticalAlign: 'center',
      display: 'flex',
      '& .assetName': {
        fontSize: '24px',
      },
      '& .hypen': {
        margin: '0px 8px',
        fontSize: 24,
        color: 'rgba(255,255,255,0.87)',
        fontWeight: 300,
      },
      '& .inspectionIdGrid': {
        height: '5px',
        width: '5px',
        borderRadius: '50%',
        display: 'inline-block',
        backgroundColor: '#2AAB3F',
        margin: '16px 12px',
      },
    },
  }),
);

export default useStyles;
